// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ViewReviewAdminMessage-errorMessage-mlefL {
  margin: 5px 0px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
}
.ViewReviewAdminMessage-space1-eGfZT {
	margin-bottom: 6px !important;
}
.ViewReviewAdminMessage-space2-FqB1z {
	margin-bottom: 12px !important;
}
.ViewReviewAdminMessage-space3-GV73R {
	margin-bottom: 18px !important;
}
.ViewReviewAdminMessage-space4-DwRUf {
	margin-bottom: 24px !important;
}
.ViewReviewAdminMessage-space5-S_1Z9 {
	margin-bottom: 30px !important;
}
.ViewReviewAdminMessage-space6-Bt7HM {
	margin-bottom: 36px !important;
}
.ViewReviewAdminMessage-space7-zl_tt {
	margin-bottom: 42px !important;
}
.ViewReviewAdminMessage-spaceTop8-DNpbU {
	margin-bottom: 48px !important;
}
.ViewReviewAdminMessage-spaceTop1-brLOg {
	margin-top: 6px !important;
}
.ViewReviewAdminMessage-spaceTop2-vV9ei {
	margin-top: 12px !important;
}
.ViewReviewAdminMessage-spaceTop3-arLsW {
	margin-top: 18px !important;
}
.ViewReviewAdminMessage-spaceTop4-OQUrX {
	margin-top: 24px !important;
}
.ViewReviewAdminMessage-spaceTop5-pXgwv {
	margin-top: 30px !important;
}
.ViewReviewAdminMessage-spaceTop6-xkGJd {
	margin-top: 36px !important;
}
.ViewReviewAdminMessage-spaceTop7-hN96p {
	margin-top: 42px !important;
}
.ViewReviewAdminMessage-spaceTop8-DNpbU {
	margin-top: 48px !important;
}
.ViewReviewAdminMessage-noMargin-UJrFk {
	margin: 0px !important;
}
.ViewReviewAdminMessage-padding1-Tbxwz {
	padding-bottom: 6px !important;
}
.ViewReviewAdminMessage-padding2-S0KBp {
	padding-bottom: 12px !important;
}
.ViewReviewAdminMessage-padding3-e_Fya {
	padding-bottom: 18px !important;
}
.ViewReviewAdminMessage-padding4-R19Yk {
	padding-bottom: 24px !important;
}
.ViewReviewAdminMessage-padding5-nfoCM {
	padding-bottom: 30px !important;
}
.ViewReviewAdminMessage-padding6-vAZ4N {
	padding-bottom: 36px !important;
}
.ViewReviewAdminMessage-padding7-_7hcl {
	padding-bottom: 42px !important;
}
.ViewReviewAdminMessage-paddingTop1-Fsbh5 {
	padding-top: 6px !important;
}
.ViewReviewAdminMessage-paddingTop2-bg74U {
	padding-top: 12px !important;
}
.ViewReviewAdminMessage-paddingTop3-kQzC7 {
	padding-top: 18px !important;
}
.ViewReviewAdminMessage-paddingTop4-k1Vqt {
	padding-top: 24px !important;
}
.ViewReviewAdminMessage-paddingTop5-OTRQt {
	padding-top: 30px !important;
}
.ViewReviewAdminMessage-paddingTop6-lfs10 {
	padding-top: 36px !important;
}
.ViewReviewAdminMessage-paddingTop7-Rjya9 {
	padding-top: 42px !important;
}
.ViewReviewAdminMessage-noPadding-Mf6uJ {
	padding: 0px !important;
}
.ViewReviewAdminMessage-textBold-wFQzB {
	font-weight: 500 !important;
}
.ViewReviewAdminMessage-textBolder-PMJfI {
	font-weight: 700 !important;
}
.ViewReviewAdminMessage-textNormal-amgd0 {
	font-weight: normal !important;
}
.ViewReviewAdminMessage-spaceBottom20-tuz1W {
	margin-bottom: 20px;
}
.ViewReviewAdminMessage-spaceBottom10-sQ1wo {
	margin-bottom: 10px;
}
.ViewReviewAdminMessage-marginNone-kzEDQ {
	margin: 0;
}
.ViewReviewAdminMessage-spaceBottom15-lc1yk {
	margin-bottom: 15px;
}
.ViewReviewAdminMessage-marginTopNone-ecWgC {
	margin-top: 0;
}
.ViewReviewAdminMessage-spaceTop11-LqhJ7 {
	margin-top: 11px;
}
.ViewReviewAdminMessage-spaceTop21-gBdw_ {
	margin-top: 21px;
}
.ViewReviewAdminMessage-spaceTop20-DNpIG {
	margin-top: 20px;
}
.ViewReviewAdminMessage-spaceTop10-P6hgy {
	margin-top: 10px;
}
/*New Design Text Colors */
.ViewReviewAdminMessage-textDarkBlue-UZPtO {
	color: rgb(20, 39, 94) !important;
}
.ViewReviewAdminMessage-textLightBlue-GtCBz {
	color: rgb(57, 87, 106) !important;
}
.ViewReviewAdminMessage-textLightSandleGreen-GSW1X {
	color: rgb(76, 86, 41) !important;
}
.ViewReviewAdminMessage-textLightBrown-goVPB {
	color: rgb(115, 79, 33) !important;
}
.ViewReviewAdminMessage-textMediumMaroon-b3oPV {
	color: rgb(87, 37, 51) !important;
}
.ViewReviewAdminMessage-textBrown-zWwEj {
	color: rgb(160, 47, 24) !important;
}
.ViewReviewAdminMessage-textMaroon-s1IFt {
	color: rgb(155, 49, 67) !important;
}
.ViewReviewAdminMessage-textDarkBrown-ONARL {
	color: rgb(83, 18, 16) !important;
}
.ViewReviewAdminMessage-textMediumBrown-D2ozj {
	color: rgb(142, 28, 10) !important;
}
.ViewReviewAdminMessage-textSkyBlue-gnbop {
	color: rgb(37, 117, 141) !important;
}
.ViewReviewAdminMessage-textGray-L01e2 {
	color: rgb(77, 65, 51) !important;
}
/*************************Common Styles start******************************************/
.ViewReviewAdminMessage-btnRadius-bvXK6 {
	border-radius: 4px;
}
.ViewReviewAdminMessage-linkBtn-BHA2r {
	border-radius: 4px;
	padding: 12px 21px;
}
.ViewReviewAdminMessage-noMargin-UJrFk {
	margin: 0px;
}
.ViewReviewAdminMessage-noBorder-cA3Nm {
	border: 0px none !important;
}
/*************************Common Styles end******************************************/
/*************************Sidenavigation Styles start******************************************/
.ViewReviewAdminMessage-sidebarDesign-w9Svl {
	padding: 50px 0 30px;
	background: #ffffff;
}
.ViewReviewAdminMessage-sidebarContainer-F8jAP {
	border: 1px solid var(--border-color);
	border-radius: 8px;
	padding: 20px;
}
.ViewReviewAdminMessage-textCenter-yzFHy {
	text-align: center;
}
.ViewReviewAdminMessage-profileAvatarSection-gdrPI {
	position: relative;
	margin: 0 auto;
}
.ViewReviewAdminMessage-profileAvatarLink-Ow8rd {
	-webkit-backface-visibility: hidden;
	        backface-visibility: hidden;
	position: relative;
	display: inline-block;
	overflow: hidden;
	border-radius: 50%;
}
.ViewReviewAdminMessage-profileName-ObobG {
	font-size: 16px;
}
.ViewReviewAdminMessage-profileDetail-zrGep {
	font-size: 12px;
	color: #767676;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
}
.ViewReviewAdminMessage-horizontalLine-QIXYd {
	margin-top: 15px;
	margin-bottom: 15px;
	border: 0;
	border-top: 2px solid #9b9b9b;
}
.ViewReviewAdminMessage-textGray-L01e2 {
	color: #9b9b9b;
}
.ViewReviewAdminMessage-textBold-wFQzB {
	font-weight: bold;
}
.ViewReviewAdminMessage-textLeft-RcUgx {
	text-align: left;
}
.ViewReviewAdminMessage-textRight-m0R9F {
	text-align: right;
}
/*************************Sidenavigation Styles End******************************************/
/*************************Message Styles start******************************************/
.ViewReviewAdminMessage-contextPadding-JW9NL {
	padding: 20px;
	border-radius: 8px;
}
.ViewReviewAdminMessage-rowCondensed-Wz_lc {
	margin-left: -6px;
	margin-right: -6px;
}
.ViewReviewAdminMessage-textBody-IeKew {
	margin: 0;
	padding: 20px;
	text-align: left;
}
.ViewReviewAdminMessage-bottomButton-DDcSh {
	text-align: right;
	padding: 20px;
}
.ViewReviewAdminMessage-textAreaBox-iM7zT {
	height: 77px !important;
	border: 0px;
	margin-top: 0;
	-webkit-box-shadow: none;
	        box-shadow: none;
	border: 1px solid var(--border-color);
	resize: none;
}
.ViewReviewAdminMessage-textAreaBox-iM7zT:focus,
.ViewReviewAdminMessage-textAreaBox-iM7zT:active {
	border: 1px solid var(--border-color) !important
}
.ViewReviewAdminMessage-btnRight-Ec9zj {
	margin-left: 10px;
}
.ViewReviewAdminMessage-panelDark-oj0A_ {
	background-color: #ecf0ec;
	margin: 0;
}
.ViewReviewAdminMessage-timeText-n51_S {
	color: #767676;
}
.ViewReviewAdminMessage-timeText-n51_S:hover,
.ViewReviewAdminMessage-timeText-n51_S:focus {
	color: #767676;
	text-decoration: none;
	outline: none;
}
/*************************Chat bubble Right & Left Styles start******************************************/
.ViewReviewAdminMessage-panelQuote-uJKpo {
	margin-left: 0;
	margin-right: 0;
	position: relative;
	border-radius: 0px;
}
.ViewReviewAdminMessage-panelBubble-mt33I {
	display: block;
	position: relative;
	height: auto;
	border-radius: 0;
	border: none;
	-webkit-box-shadow: none;
	        box-shadow: none;
}
.ViewReviewAdminMessage-panelBubbleLeft-ulQL3::before {
	content: ' ';
	position: absolute;
	display: inline-block;
	width: 0;
	height: 0;
	bottom: auto;
	border: 10px solid transparent;
	border-left: 0;
	border-right-color: #fff;
	top: 0px;
	left: initial;
	right: 100%;
	border-width: 0 24px 24px 0;
	border-color: transparent #fff transparent transparent;
}
.ViewReviewAdminMessage-panelBubbleLeft-ulQL3::after {
	content: ' ';
	position: absolute;
	width: 0;
	height: 0;
	left: -20px;
	right: auto;
	top: 0px;
	bottom: auto;
	border-width: 0 22px 22px 0;
	border-color: transparent #fff transparent transparent;
}
.ViewReviewAdminMessage-panelBubbleRight-vESvs::before {
	content: "";
	display: inline-block;
	position: absolute;
	right: -33px;
	top: 0px;
	left: 100%;
	border: 10px solid transparent;
	border-left-color: #fff;
	border-width: 25px 25px 0 0;
	border-color: #fff transparent transparent;
	z-index: 3;
}
.ViewReviewAdminMessage-panelBubbleRight-vESvs::after {
	content: ' ';
	position: absolute;
	width: 0;
	height: 0;
	left: -20px;
	right: auto;
	top: 0px;
	bottom: auto;
	border-width: 0 25px 25px 0;
	border-color: transparent var(--border-secondary-color) transparent transparent;
}
.ViewReviewAdminMessage-radiusColor-tYXyK::after {
	content: '';
	position: absolute;
	right: -43px;
	top: -1px;
	left: auto;
	width: 43px;
	height: 46px;
	background: #F7FAFF;
	border-top-left-radius: 30px;
	border-bottom-right-radius: 30px;
	z-index: 3;
}
.ViewReviewAdminMessage-radiusColorTwo-V5yNJ::after {
	content: '';
	position: absolute;
	left: -37px;
	top: 0;
	right: auto;
	width: 38px;
	height: 46px;
	background: #F7FAFF;
	border-top-right-radius: 30px;
	border-bottom-left-radius: 30px;
	z-index: 3;
}
.ViewReviewAdminMessage-panelText-Xfp1y {
	word-break: break-all !important;
}
/*************************Chat bubble Right & Left Styles end******************************************/
/*************************Notification Message Styles start******************************************/
.ViewReviewAdminMessage-horizontalText-yNWko {
	overflow: hidden;
	text-align: center;
}
.ViewReviewAdminMessage-textWrapper-jkLzs {
	position: relative;
}
.ViewReviewAdminMessage-textWrapper-jkLzs::before {
	content: "";
	position: absolute;
	border-bottom: 1px solid var(--border-secondary-color);
	width: 500px;
	top: 50%;
	right: 100%;
	margin-right: 18px;
}
.ViewReviewAdminMessage-textWrapper-jkLzs::after {
	content: "";
	position: absolute;
	border-bottom: 1px solid var(--border-secondary-color);
	width: 500px;
	top: 50%;
	left: 100%;
	margin-left: 18px;
}
/*************************Notification Message Styles end******************************************/
.ViewReviewAdminMessage-horizondalLine-IXWO3 {
	margin-top: 20px;
	margin-bottom: 20px;
	border: 0;
	border-top: 1px solid var(--border-color);
}
.ViewReviewAdminMessage-textLeft-RcUgx {
	text-align: left;
}
.ViewReviewAdminMessage-textRight-m0R9F {
	text-align: right;
}
.ViewReviewAdminMessage-textGray-L01e2 {
	color: #9b9b9b;
	font-size: 14px;
}
.ViewReviewAdminMessage-chevronIcon-zkzde {
	font-size: 1.5em;
	margin-top: 10px;
	font-weight: normal;
	font-style: normal;
}
.ViewReviewAdminMessage-timerIcon-KYJGX {
	font-size: 1.5em;
	font-weight: normal;
	font-style: normal;
	position: relative;
	bottom: 2px;
}
.ViewReviewAdminMessage-checkInDate-n2gq9 {
	font-size: 14px;
	color: var(--common-text-color);
}
.ViewReviewAdminMessage-pullLeft-f8sbV {
	float: left;
}
.ViewReviewAdminMessage-pullRight-j6X6s {
	float: right;
}
/** Discount **/
.ViewReviewAdminMessage-discountText-lfMwx {
	color: #3fb34f;
}
a,
a:hover,
a:focus,
a:active {
	text-decoration: none;
}
.ViewReviewAdminMessage-paddingRight-Zp8eq {
	padding: 0 0 0 35px;
}
.ViewReviewAdminMessage-displayTable-okOyH {
	width: 100%;
	display: table;
}
.ViewReviewAdminMessage-displayTableRow-XeOtV {
	width: 100%;
	display: table-row;
}
.ViewReviewAdminMessage-displayTableCell-bhZDv {
	display: table-cell;
	vertical-align: top;
}
.ViewReviewAdminMessage-displayTableWidth-Dw8re {
	width: 100%;
	position: relative;
}
.ViewReviewAdminMessage-profileAvatarSection-gdrPI {
	margin: 0 0 0 6px;
	position: relative;
	z-index: 5;
}
.ViewReviewAdminMessage-displayTableCellTop-k_QIO {
	display: table-cell;
	vertical-align: top;
}
.ViewReviewAdminMessage-profileAvatarSectionLeft-tsElY {
	position: relative;
	z-index: 5;
	margin: 0px 6px 0 0px;
}
.ViewReviewAdminMessage-guestHost-dXIi3 {
	text-align: center;
	margin-bottom: 25px;
	background: #fff;
	padding: 10px 0;
}
.ViewReviewAdminMessage-hostChat-GVdgK {
	display: inline-block;
	vertical-align: middle;
}
.ViewReviewAdminMessage-hostChat-GVdgK img {
	width: 110px;
	border-radius: 50%;
	border: 2px solid #fff;
}
.ViewReviewAdminMessage-centerChatIcon-sXkO4 {
	height: 45px;
	width: 45px;
	margin-left: -20px;
	margin-right: -20px;
	position: relative;
	z-index: 2;
	text-align: center;
	display: inline-block;
	vertical-align: middle;
}
.ViewReviewAdminMessage-iconBG-w3sSJ {
	border-radius: 50%;
	border: 2px solid #ccc;
	border-width: 2px !important;
	background-color: #fff;
	text-align: center;
	height: 45px;
	width: 45px;
}
.ViewReviewAdminMessage-iconBG-w3sSJ img {
	width: 65%;
	display: inline-block;
	padding: 9px 0 0 0
}
.ViewReviewAdminMessage-hostName-c5BIC {
	display: inline-block;
	vertical-align: middle;
	background: #fff;
	padding: 10px;
	color: var(--common-text-color);
	font-size: 15px;
	width: 20%;
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;
}
.ViewReviewAdminMessage-instantIcon-uyGi1 {
	margin-top: -4px;
}
.ViewReviewAdminMessage-positionR-DIgoq {
	position: relative;
}
.ViewReviewAdminMessage-infoContentBlock-yMb4G {
	background-color: #F8F7FD;
}
.ViewReviewAdminMessage-contentBlockHeading-qpPCC {
	font-size: 18px;
	margin-bottom: 12px;
	margin-top: 0;
	font-weight: 600;
}
.ViewReviewAdminMessage-contentSectionBtn-jkvdr {
	margin-top: 20px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
}
.ViewReviewAdminMessage-contentSubText-aGzVy {
	font-size: 16px;
}
/* =============New css ================*/
.ViewReviewAdminMessage-tripDetailHeading-h5RLI {
	font-size: 16px;
}
.ViewReviewAdminMessage-tripDetailGrey-tkNGV {
	color: var(--common-text-Secondry-color);
	font-size: 16px;
}
.ViewReviewAdminMessage-paymentDetailText-yEkGs {
	color: var(--common-text-Secondry-color);
	font-size: 16px;
	margin-bottom: 10px;
}
.ViewReviewAdminMessage-paymentTotal-Gor6q {
	font-size: 18px;
}
.ViewReviewAdminMessage-messageBoxBg-rAAEr {
	background-color: var(--background-common-color);
	padding: 20px 20px 40px 20px;
	border-radius: 8px;
}
.ViewReviewAdminMessage-messageBoxStyle-U2rTt {
	width: 90%;
}
.ViewReviewAdminMessage-topMessageBar-mD4wf {
	background-color: transparent;
}
.ViewReviewAdminMessage-messageSendIcon-N6Bjb,
.ViewReviewAdminMessage-messageSendIcon-N6Bjb:hover,
.ViewReviewAdminMessage-messageSendIcon-N6Bjb:active,
.ViewReviewAdminMessage-messageSendIcon-N6Bjb:focus {
	background: transparent !important;
	border: 0 !important;
	outline: none;
	-webkit-box-shadow: none !important;
	        box-shadow: none !important;
	padding: 0;
	position: relative;
	z-index: 5
}
.ViewReviewAdminMessage-paddingNone-VxysI {
	padding: 0;
}
.ViewReviewAdminMessage-messageBoxSection-pMjJN {
	padding: 20px;
	background-color: var(--background-common-color);
	border-top-left-radius: 8px;
	border-top-right-radius: 8px;
}
.ViewReviewAdminMessage-panelBubble-mt33I {
	margin-bottom: 0;
}
.ViewReviewAdminMessage-userDetailSec-m_6L8 {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-pack: center;
	    -ms-flex-pack: center;
	        justify-content: center;
	gap: 18px;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	margin-bottom: 22px;
}
.ViewReviewAdminMessage-userDetailHostName-_E0Lj {
	font-size: 16px;
}
.ViewReviewAdminMessage-font16-fkdfi {
	font-size: 16px;
}
.ViewReviewAdminMessage-nameSection-_GOGQ {
	margin-bottom: 8px;
}
.ViewReviewAdminMessage-verifyReviewCountSec-i7Z9l {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 3px;
}
.ViewReviewAdminMessage-statusText-DWSvW {
	font-size: 16px;
	padding-right: 8px;
}
.ViewReviewAdminMessage-dotText-S2bkS {
	width: 4px;
	height: 4px;
	border-radius: 50%;
	background-color: var(--common-text-color);
	position: absolute;
	top: 38%;

}
.ViewReviewAdminMessage-dateText-XD4fU {
	font-size: 14px;
	color: var(--common-text-Secondry-color);
	padding-left: 8px;
}
.ViewReviewAdminMessage-messageThreadSection-T68oq {
	padding: 0 20px 40px 20px;
}
.ViewReviewAdminMessage-topRadiusColor-BatCj::after {
	right: 50px;
	top: 20px;
	border-left: 1px solid var(--border-color);
	background: var(--background-common-color);
}
.ViewReviewAdminMessage-topMessageBar-mD4wf::before {
	right: -23px;
	top: 1px;
	left: auto;
}
.ViewReviewAdminMessage-panelBubbleLeft-ulQL3 {
	background-color: #ffffff;
	padding: 17px;
}
.ViewReviewAdminMessage-panelSendToBubble-BRxdt {
	background-color: #EDF4FF;
	padding: 17px;
}
.ViewReviewAdminMessage-fromRadius-GxNX_:after {
	left: 0px;
	top: 0;
	right: auto;
	width: 46px;
	border-top-right-radius: 30px;
	border-bottom-left-radius: 30px;
	background: var(--background-common-color);
}
.ViewReviewAdminMessage-toRadius-DoNLn:after {
	right: 4px;
	top: -1px;
	left: auto;
	width: 46px;
	border-top-left-radius: 30px;
	border-bottom-right-radius: 30px;
}
.ViewReviewAdminMessage-panelSendToBubble-BRxdt:before {
	border-color: #EDF4FF transparent transparent;
}
.ViewReviewAdminMessage-panelSendToBubble-BRxdt::after {
	content: '';
	position: absolute;
	right: -45px;
	top: -1px;
	left: auto;
	width: 46px;
	height: 46px;
	background: var(--background-common-color);
	border-top-left-radius: 30px;
	border-bottom-right-radius: 30px;
	z-index: 3;
	-webkit-transform: rotate(-14deg);
	    -ms-transform: rotate(-14deg);
	        transform: rotate(-14deg);

}
.ViewReviewAdminMessage-panelLeftMessage-lbjDV {
	border-radius: 0 8px 8px 8px;
}
.ViewReviewAdminMessage-panelRightMessage-M2pro {
	border-radius: 8px 0 8px 8px;
}
.ViewReviewAdminMessage-messageDateText-pJ2yz {
	color: var(--common-text-Secondry-color);
	font-size: 10px;
}
.ViewReviewAdminMessage-txtBreak-IstlX {
	word-break: break-word;
}
.ViewReviewAdminMessage-messageProfilePicSec-LRZqf {
	width: 50px;
}
.ViewReviewAdminMessage-width100-icj74 {
	width: 100%;
}
.ViewReviewAdminMessage-messageBoxFlex-PdQYs {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	position: relative;
}
.ViewReviewAdminMessage-profileAvatarSection-gdrPI {
	width: 48px;
}
.ViewReviewAdminMessage-profileAvatarSectionLeft-tsElY .ViewReviewAdminMessage-profileAvatarLink-Ow8rd {
	position: relative;
	right: 3px;
	top: 1px;
}
.ViewReviewAdminMessage-tripCheckinCheckout-Sbq7w {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	-webkit-box-pack: justify;
	    -ms-flex-pack: justify;
	        justify-content: space-between;
}
.ViewReviewAdminMessage-userDetailDotText-sZd41 {
	width: 3px;
	height: 3px;
	border-radius: 50%;
	background-color: var(--common-text-Secondry-color);
	position: relative;
	margin-top: 7px;
	margin-left: 7px;
	margin-right: 7px;
}
.ViewReviewAdminMessage-tripArrowSec-Zph1_ {
	margin: 0 10px;
}
.ViewReviewAdminMessage-checkDate-IuAOK {
	word-break: break-word;
}
.ViewReviewAdminMessage-paymentFlex-yRd2y {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-pack: justify;
	    -ms-flex-pack: justify;
	        justify-content: space-between;
	-webkit-column-gap: 5px;
	   -moz-column-gap: 5px;
	        column-gap: 5px;
}
.ViewReviewAdminMessage-timerSection-okZb0 {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-column-gap: 3px;
	   -moz-column-gap: 3px;
	        column-gap: 3px;
}
/* ==============New css============== */
.ViewReviewAdminMessage-msgSendIcon-xSw0Y {
	width: 100%;
	max-width: 72px;
	min-width: 72px;
}
.ViewReviewAdminMessage-deleteButton-uZ3gA {
	background: red;
	padding: 5px;
	color: white;
	border-radius: 12px;
	border-style: none;
	outline: none;
	margin-top: 10px;
}
@media (max-width: 1023px) and (min-width: 768px) {
	.ViewReviewAdminMessage-noPaddingRight-eZ8vA {
		padding-right: 0;
	}

	.ViewReviewAdminMessage-hostChat-GVdgK img {
		width: 95px;
	}

	.ViewReviewAdminMessage-iconBG-w3sSJ img {
		padding: 8px 0 0 0;
	}

	.ViewReviewAdminMessage-iconBG-w3sSJ {
		height: 40px;
		width: 40px;
	}

	.ViewReviewAdminMessage-centerChatIcon-sXkO4 {
		height: 40px;
		width: 40px;
	}

	.ViewReviewAdminMessage-hostName-c5BIC {
		width: 25%;
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
	}

	.ViewReviewAdminMessage-hostNameColor-k63nN {
		color: var(--common-text-color) !important;
	}
}
@media (max-width: 767px) {
	.ViewReviewAdminMessage-paddingRight-Zp8eq {
		padding: 0 0 0 0;
	}

	.ViewReviewAdminMessage-panelBubbleRight-vESvs::before {
		display: none !important;
	}

	.ViewReviewAdminMessage-panelBubbleLeft-ulQL3::before {
		display: none !important;
	}

	.ViewReviewAdminMessage-panelBubbleRight-vESvs::after {
		display: none;
	}

	.ViewReviewAdminMessage-panelBubbleLeft-ulQL3::after {
		display: none;
	}

	.ViewReviewAdminMessage-profileAvatarSection-gdrPI {
		margin: 0 0 0 13px;
	}

	.ViewReviewAdminMessage-displayTableWidth-Dw8re {
		width: 100%;
	}

	.ViewReviewAdminMessage-displayTableWidthTwo-x32A8 {
		width: 20%;
	}

	.ViewReviewAdminMessage-profileAvatarSectionLeft-tsElY {
		margin: 0 10px 0 0;
		position: relative;
		z-index: 5;
	}

	.ViewReviewAdminMessage-radiusColor-tYXyK::after {
		display: none;
	}

	.ViewReviewAdminMessage-radiusColorTwo-V5yNJ::after {
		display: none;
	}

	.ViewReviewAdminMessage-displayTableCell-bhZDv {
		display: table-cell;
		vertical-align: middle;
	}

	.ViewReviewAdminMessage-tripDetailGrey-tkNGV {
		font-size: 14px;
	}

	.ViewReviewAdminMessage-paymentDetailText-yEkGs {
		font-size: 14px;
	}

	.ViewReviewAdminMessage-paymentTotal-Gor6q {
		font-size: 16px;
	}

	.ViewReviewAdminMessage-tripDetailHeading-h5RLI {
		font-size: 15px;
	}

	.ViewReviewAdminMessage-userDetailSec-m_6L8 {
		-webkit-box-orient: vertical;
		-webkit-box-direction: normal;
		    -ms-flex-direction: column;
		        flex-direction: column;
	}

	.ViewReviewAdminMessage-profileDetail-zrGep {
		-webkit-box-pack: center;
		    -ms-flex-pack: center;
		        justify-content: center;
	}

	.ViewReviewAdminMessage-msgSendIcon-xSw0Y {
		max-width: 55px;
		min-width: 55px;
	}

	.ViewReviewAdminMessage-panelLeftMessage-lbjDV {
		border-radius: 8px !important;
	}

	.ViewReviewAdminMessage-panelRightMessage-M2pro {
		border-radius: 8px !important;
	}

	.ViewReviewAdminMessage-sidebarDesign-w9Svl {
		padding-top: 25px;
	}
}
@media screen and (max-width: 768px) {
	.ViewReviewAdminMessage-hideSm-ETeWW {
		display: none;
	}
}
@media (max-width: 320px) {
	.ViewReviewAdminMessage-noPaddingRight-eZ8vA {
		padding-right: 0;
	}
}
@media screen and (min-width:1281px) {
	/* .messageBoxBg{
		height: 650px;
		overflow-y:scroll ;
	} */
	/* .messageBoxSection{
		position: sticky;
		z-index: 7;
		top: 0px;
	} */

}
.ViewReviewAdminMessage-displayFlex-XlDaX {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
}
@media screen and (min-width:768px) {
	.ViewReviewAdminMessage-messageSendBtnSec-QbQXk {
		position: relative;
	}

	.ViewReviewAdminMessage-messageSendIcon-N6Bjb::before {
		content: '';
		position: absolute;
		width: 25px;
		height: 1px;
		background-color: var(--border-color);
		left: -3px;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/utils.css","webpack://./src/components/helpers.css","webpack://./src/components/ViewReviewAdminMessage/ViewReviewAdminMessage.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;ACNA;CACC,6BAA6B;AAC9B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,0BAA0B;AAC3B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,sBAAsB;AACvB;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,uBAAuB;AACxB;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,mBAAmB;AACpB;AAEA;CACC,mBAAmB;AACpB;AAEA;CACC,SAAS;AACV;AAEA;CACC,mBAAmB;AACpB;AAEA;CACC,aAAa;AACd;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,gBAAgB;AACjB;AAEA,0BAA0B;AAE1B;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,mCAAmC;AACpC;AAEA;CACC,iCAAiC;AAClC;ACzNA,uFAAuF;AACvF;CACC,kBAAkB;AACnB;AAEA;CACC,kBAAkB;CAClB,kBAAkB;AACnB;AAEA;CACC,WAAW;AACZ;AAEA;CACC,2BAA2B;AAC5B;AAEA,qFAAqF;AACrF,+FAA+F;AAC/F;CACC,oBAAoB;CACpB,mBAAmB;AACpB;AAEA;CACC,qCAAqC;CACrC,kBAAkB;CAClB,aAAa;AACd;AAEA;CACC,kBAAkB;AACnB;AAEA;CACC,kBAAkB;CAClB,cAAc;AACf;AAEA;CACC,mCAA2B;SAA3B,2BAA2B;CAC3B,kBAAkB;CAClB,qBAAqB;CACrB,gBAAgB;CAChB,kBAAkB;AACnB;AAEA;CACC,eAAe;AAChB;AAEA;CACC,eAAe;CACf,cAAc;CACd,oBAAa;CAAb,oBAAa;CAAb,aAAa;AACd;AAEA;CACC,gBAAgB;CAChB,mBAAmB;CACnB,SAAS;CACT,6BAA6B;AAC9B;AAEA;CACC,cAAc;AACf;AAEA;CACC,iBAAiB;AAClB;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,iBAAiB;AAClB;AAEA,6FAA6F;AAC7F,wFAAwF;AACxF;CACC,aAAa;CACb,kBAAkB;AACnB;AAEA;CACC,iBAAiB;CACjB,kBAAkB;AACnB;AAEA;CACC,SAAS;CACT,aAAa;CACb,gBAAgB;AACjB;AAEA;CACC,iBAAiB;CACjB,aAAa;AACd;AAEA;CACC,uBAAuB;CACvB,WAAW;CACX,aAAa;CACb,wBAAgB;SAAhB,gBAAgB;CAChB,qCAAqC;CACrC,YAAY;AACb;AAEA;;CAEC;AACD;AAEA;CACC,iBAAiB;AAClB;AAEA;CACC,yBAAyB;CACzB,SAAS;AACV;AAEA;CACC,cAAc;AACf;AAEA;;CAEC,cAAc;CACd,qBAAqB;CACrB,aAAa;AACd;AAEA,yGAAyG;AACzG;CACC,cAAc;CACd,eAAe;CACf,kBAAkB;CAClB,kBAAkB;AACnB;AAEA;CACC,cAAc;CACd,kBAAkB;CAClB,YAAY;CACZ,gBAAgB;CAChB,YAAY;CACZ,wBAAgB;SAAhB,gBAAgB;AACjB;AAEA;CACC,YAAY;CACZ,kBAAkB;CAClB,qBAAqB;CACrB,QAAQ;CACR,SAAS;CACT,YAAY;CACZ,8BAA8B;CAC9B,cAAc;CACd,wBAAwB;CACxB,QAAQ;CACR,aAAa;CACb,WAAW;CACX,2BAA2B;CAC3B,sDAAsD;AACvD;AAEA;CACC,YAAY;CACZ,kBAAkB;CAClB,QAAQ;CACR,SAAS;CACT,WAAW;CACX,WAAW;CACX,QAAQ;CACR,YAAY;CACZ,2BAA2B;CAC3B,sDAAsD;AACvD;AAEA;CACC,WAAW;CACX,qBAAqB;CACrB,kBAAkB;CAClB,YAAY;CACZ,QAAQ;CACR,UAAU;CACV,8BAA8B;CAC9B,uBAAuB;CACvB,2BAA2B;CAC3B,0CAA0C;CAC1C,UAAU;AACX;AAEA;CACC,YAAY;CACZ,kBAAkB;CAClB,QAAQ;CACR,SAAS;CACT,WAAW;CACX,WAAW;CACX,QAAQ;CACR,YAAY;CACZ,2BAA2B;CAC3B,+EAA+E;AAChF;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,YAAY;CACZ,SAAS;CACT,UAAU;CACV,WAAW;CACX,YAAY;CACZ,mBAAmB;CACnB,4BAA4B;CAC5B,gCAAgC;CAChC,UAAU;AACX;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,WAAW;CACX,MAAM;CACN,WAAW;CACX,WAAW;CACX,YAAY;CACZ,mBAAmB;CACnB,6BAA6B;CAC7B,+BAA+B;CAC/B,UAAU;AACX;AAEA;CACC,gCAAgC;AACjC;AAEA,uGAAuG;AACvG,qGAAqG;AACrG;CACC,gBAAgB;CAChB,kBAAkB;AACnB;AAEA;CACC,kBAAkB;AACnB;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,sDAAsD;CACtD,YAAY;CACZ,QAAQ;CACR,WAAW;CACX,kBAAkB;AACnB;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,sDAAsD;CACtD,YAAY;CACZ,QAAQ;CACR,UAAU;CACV,iBAAiB;AAClB;AAEA,mGAAmG;AACnG;CACC,gBAAgB;CAChB,mBAAmB;CACnB,SAAS;CACT,yCAAyC;AAC1C;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,iBAAiB;AAClB;AAEA;CACC,cAAc;CACd,eAAe;AAChB;AAEA;CACC,gBAAgB;CAChB,gBAAgB;CAChB,mBAAmB;CACnB,kBAAkB;AACnB;AAEA;CACC,gBAAgB;CAChB,mBAAmB;CACnB,kBAAkB;CAClB,kBAAkB;CAClB,WAAW;AACZ;AAEA;CACC,eAAe;CACf,+BAA+B;AAChC;AAEA;CACC,WAAW;AACZ;AAEA;CACC,YAAY;AACb;AAEA,eAAe;AACf;CACC,cAAc;AACf;AAEA;;;;CAIC,qBAAqB;AACtB;AAEA;CACC,mBAAmB;AACpB;AAEA;CACC,WAAW;CACX,cAAc;AACf;AAEA;CACC,WAAW;CACX,kBAAkB;AACnB;AAEA;CACC,mBAAmB;CACnB,mBAAmB;AACpB;AAEA;CACC,WAAW;CACX,kBAAkB;AACnB;AAEA;CACC,iBAAiB;CACjB,kBAAkB;CAClB,UAAU;AACX;AAEA;CACC,mBAAmB;CACnB,mBAAmB;AACpB;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,qBAAqB;AACtB;AAEA;CACC,kBAAkB;CAClB,mBAAmB;CACnB,gBAAgB;CAChB,eAAe;AAChB;AAEA;CACC,qBAAqB;CACrB,sBAAsB;AACvB;AAEA;CACC,YAAY;CACZ,kBAAkB;CAClB,sBAAsB;AACvB;AAEA;CACC,YAAY;CACZ,WAAW;CACX,kBAAkB;CAClB,mBAAmB;CACnB,kBAAkB;CAClB,UAAU;CACV,kBAAkB;CAClB,qBAAqB;CACrB,sBAAsB;AACvB;AAEA;CACC,kBAAkB;CAClB,sBAAsB;CACtB,4BAA4B;CAC5B,sBAAsB;CACtB,kBAAkB;CAClB,YAAY;CACZ,WAAW;AACZ;AAEA;CACC,UAAU;CACV,qBAAqB;CACrB;AACD;AAEA;CACC,qBAAqB;CACrB,sBAAsB;CACtB,gBAAgB;CAChB,aAAa;CACb,+BAA+B;CAC/B,eAAe;CACf,UAAU;CACV,uBAAuB;CACvB,gBAAgB;CAChB,mBAAmB;AACpB;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,kBAAkB;AACnB;AAEA;CACC,yBAAyB;AAC1B;AAEA;CACC,eAAe;CACf,mBAAmB;CACnB,aAAa;CACb,gBAAgB;AACjB;AAEA;CACC,gBAAgB;CAChB,oBAAa;CAAb,oBAAa;CAAb,aAAa;AACd;AAEA;CACC,eAAe;AAChB;AAEA,yCAAyC;AACzC;CACC,eAAe;AAChB;AAEA;CACC,wCAAwC;CACxC,eAAe;AAChB;AAEA;CACC,wCAAwC;CACxC,eAAe;CACf,mBAAmB;AACpB;AAEA;CACC,eAAe;AAChB;AAEA;CACC,gDAAgD;CAChD,4BAA4B;CAC5B,kBAAkB;AACnB;AAEA;CACC,UAAU;AACX;AAEA;CACC,6BAA6B;AAC9B;AAEA;;;;CAIC,kCAAkC;CAClC,oBAAoB;CACpB,aAAa;CACb,mCAA2B;SAA3B,2BAA2B;CAC3B,UAAU;CACV,kBAAkB;CAClB;AACD;AAEA;CACC,UAAU;AACX;AAEA;CACC,aAAa;CACb,gDAAgD;CAChD,2BAA2B;CAC3B,4BAA4B;AAC7B;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;CACvB,SAAS;CACT,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,mBAAmB;AACpB;AAEA;CACC,eAAe;AAChB;AAEA;CACC,eAAe;AAChB;AAEA;CACC,kBAAkB;AACnB;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,QAAQ;AACT;AAEA;CACC,eAAe;CACf,kBAAkB;AACnB;AAEA;CACC,UAAU;CACV,WAAW;CACX,kBAAkB;CAClB,0CAA0C;CAC1C,kBAAkB;CAClB,QAAQ;;AAET;AAEA;CACC,eAAe;CACf,wCAAwC;CACxC,iBAAiB;AAClB;AAEA;CACC,yBAAyB;AAC1B;AAEA;CACC,WAAW;CACX,SAAS;CACT,0CAA0C;CAC1C,0CAA0C;AAC3C;AAEA;CACC,YAAY;CACZ,QAAQ;CACR,UAAU;AACX;AAEA;CACC,yBAAyB;CACzB,aAAa;AACd;AAEA;CACC,yBAAyB;CACzB,aAAa;AACd;AAEA;CACC,SAAS;CACT,MAAM;CACN,WAAW;CACX,WAAW;CACX,6BAA6B;CAC7B,+BAA+B;CAC/B,0CAA0C;AAC3C;AAEA;CACC,UAAU;CACV,SAAS;CACT,UAAU;CACV,WAAW;CACX,4BAA4B;CAC5B,gCAAgC;AACjC;AAEA;CACC,6CAA6C;AAC9C;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,YAAY;CACZ,SAAS;CACT,UAAU;CACV,WAAW;CACX,YAAY;CACZ,0CAA0C;CAC1C,4BAA4B;CAC5B,gCAAgC;CAChC,UAAU;CACV,iCAAyB;KAAzB,6BAAyB;SAAzB,yBAAyB;;AAE1B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,wCAAwC;CACxC,eAAe;AAChB;AAEA;CACC,sBAAsB;AACvB;AAEA;CACC,WAAW;AACZ;AAEA;CACC,WAAW;AACZ;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,kBAAkB;AACnB;AAEA;CACC,WAAW;AACZ;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,QAAQ;AACT;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,yBAA8B;KAA9B,sBAA8B;SAA9B,8BAA8B;AAC/B;AAEA;CACC,UAAU;CACV,WAAW;CACX,kBAAkB;CAClB,mDAAmD;CACnD,kBAAkB;CAClB,eAAe;CACf,gBAAgB;CAChB,iBAAiB;AAClB;AAEA;CACC,cAAc;AACf;AAEA;CACC,sBAAsB;AACvB;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAA8B;KAA9B,sBAA8B;SAA9B,8BAA8B;CAC9B,uBAAe;IAAf,oBAAe;SAAf,eAAe;AAChB;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,uBAAe;IAAf,oBAAe;SAAf,eAAe;AAChB;AAEA,wCAAwC;AACxC;CACC,WAAW;CACX,eAAe;CACf,eAAe;AAChB;AAEA;CACC,eAAe;CACf,YAAY;CACZ,YAAY;CACZ,mBAAmB;CACnB,kBAAkB;CAClB,aAAa;CACb,gBAAgB;AACjB;AAEA;CACC;EACC,gBAAgB;CACjB;;CAEA;EACC,WAAW;CACZ;;CAEA;EACC,kBAAkB;CACnB;;CAEA;EACC,YAAY;EACZ,WAAW;CACZ;;CAEA;EACC,YAAY;EACZ,WAAW;CACZ;;CAEA;EACC,UAAU;EACV,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;CACpB;;CAEA;EACC,0CAA0C;CAC3C;AACD;AAEA;CACC;EACC,gBAAgB;CACjB;;CAEA;EACC,wBAAwB;CACzB;;CAEA;EACC,wBAAwB;CACzB;;CAEA;EACC,aAAa;CACd;;CAEA;EACC,aAAa;CACd;;CAEA;EACC,kBAAkB;CACnB;;CAEA;EACC,WAAW;CACZ;;CAEA;EACC,UAAU;CACX;;CAEA;EACC,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;CACX;;CAEA;EACC,aAAa;CACd;;CAEA;EACC,aAAa;CACd;;CAEA;EACC,mBAAmB;EACnB,sBAAsB;CACvB;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;CACvB;;CAEA;EACC,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;CACxB;;CAEA;EACC,eAAe;EACf,eAAe;CAChB;;CAEA;EACC,6BAA6B;CAC9B;;CAEA;EACC,6BAA6B;CAC9B;;CAEA;EACC,iBAAiB;CAClB;AACD;AAEA;CACC;EACC,aAAa;CACd;AACD;AAEA;CACC;EACC,gBAAgB;CACjB;AACD;AAEA;CACC;;;IAGG;CACH;;;;IAIG;;AAEJ;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;AACd;AAEA;CACC;EACC,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,qCAAqC;EACrC,UAAU;CACX;AACD","sourcesContent":[".errorMessage {\n  margin: 5px 0px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n}",".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}","@import '../../components/utils.css';\n@import '../../components/helpers.css';\n\n/*************************Common Styles start******************************************/\n.btnRadius {\n\tborder-radius: 4px;\n}\n\n.linkBtn {\n\tborder-radius: 4px;\n\tpadding: 12px 21px;\n}\n\n.noMargin {\n\tmargin: 0px;\n}\n\n.noBorder {\n\tborder: 0px none !important;\n}\n\n/*************************Common Styles end******************************************/\n/*************************Sidenavigation Styles start******************************************/\n.sidebarDesign {\n\tpadding: 50px 0 30px;\n\tbackground: #ffffff;\n}\n\n.sidebarContainer {\n\tborder: 1px solid var(--border-color);\n\tborder-radius: 8px;\n\tpadding: 20px;\n}\n\n.textCenter {\n\ttext-align: center;\n}\n\n.profileAvatarSection {\n\tposition: relative;\n\tmargin: 0 auto;\n}\n\n.profileAvatarLink {\n\tbackface-visibility: hidden;\n\tposition: relative;\n\tdisplay: inline-block;\n\toverflow: hidden;\n\tborder-radius: 50%;\n}\n\n.profileName {\n\tfont-size: 16px;\n}\n\n.profileDetail {\n\tfont-size: 12px;\n\tcolor: #767676;\n\tdisplay: flex;\n}\n\n.horizontalLine {\n\tmargin-top: 15px;\n\tmargin-bottom: 15px;\n\tborder: 0;\n\tborder-top: 2px solid #9b9b9b;\n}\n\n.textGray {\n\tcolor: #9b9b9b;\n}\n\n.textBold {\n\tfont-weight: bold;\n}\n\n.textLeft {\n\ttext-align: left;\n}\n\n.textRight {\n\ttext-align: right;\n}\n\n/*************************Sidenavigation Styles End******************************************/\n/*************************Message Styles start******************************************/\n.contextPadding {\n\tpadding: 20px;\n\tborder-radius: 8px;\n}\n\n.rowCondensed {\n\tmargin-left: -6px;\n\tmargin-right: -6px;\n}\n\n.textBody {\n\tmargin: 0;\n\tpadding: 20px;\n\ttext-align: left;\n}\n\n.bottomButton {\n\ttext-align: right;\n\tpadding: 20px;\n}\n\n.textAreaBox {\n\theight: 77px !important;\n\tborder: 0px;\n\tmargin-top: 0;\n\tbox-shadow: none;\n\tborder: 1px solid var(--border-color);\n\tresize: none;\n}\n\n.textAreaBox:focus,\n.textAreaBox:active {\n\tborder: 1px solid var(--border-color) !important\n}\n\n.btnRight {\n\tmargin-left: 10px;\n}\n\n.panelDark {\n\tbackground-color: #ecf0ec;\n\tmargin: 0;\n}\n\n.timeText {\n\tcolor: #767676;\n}\n\n.timeText:hover,\n.timeText:focus {\n\tcolor: #767676;\n\ttext-decoration: none;\n\toutline: none;\n}\n\n/*************************Chat bubble Right & Left Styles start******************************************/\n.panelQuote {\n\tmargin-left: 0;\n\tmargin-right: 0;\n\tposition: relative;\n\tborder-radius: 0px;\n}\n\n.panelBubble {\n\tdisplay: block;\n\tposition: relative;\n\theight: auto;\n\tborder-radius: 0;\n\tborder: none;\n\tbox-shadow: none;\n}\n\n.panelBubbleLeft::before {\n\tcontent: ' ';\n\tposition: absolute;\n\tdisplay: inline-block;\n\twidth: 0;\n\theight: 0;\n\tbottom: auto;\n\tborder: 10px solid transparent;\n\tborder-left: 0;\n\tborder-right-color: #fff;\n\ttop: 0px;\n\tleft: initial;\n\tright: 100%;\n\tborder-width: 0 24px 24px 0;\n\tborder-color: transparent #fff transparent transparent;\n}\n\n.panelBubbleLeft::after {\n\tcontent: ' ';\n\tposition: absolute;\n\twidth: 0;\n\theight: 0;\n\tleft: -20px;\n\tright: auto;\n\ttop: 0px;\n\tbottom: auto;\n\tborder-width: 0 22px 22px 0;\n\tborder-color: transparent #fff transparent transparent;\n}\n\n.panelBubbleRight::before {\n\tcontent: \"\";\n\tdisplay: inline-block;\n\tposition: absolute;\n\tright: -33px;\n\ttop: 0px;\n\tleft: 100%;\n\tborder: 10px solid transparent;\n\tborder-left-color: #fff;\n\tborder-width: 25px 25px 0 0;\n\tborder-color: #fff transparent transparent;\n\tz-index: 3;\n}\n\n.panelBubbleRight::after {\n\tcontent: ' ';\n\tposition: absolute;\n\twidth: 0;\n\theight: 0;\n\tleft: -20px;\n\tright: auto;\n\ttop: 0px;\n\tbottom: auto;\n\tborder-width: 0 25px 25px 0;\n\tborder-color: transparent var(--border-secondary-color) transparent transparent;\n}\n\n.radiusColor::after {\n\tcontent: '';\n\tposition: absolute;\n\tright: -43px;\n\ttop: -1px;\n\tleft: auto;\n\twidth: 43px;\n\theight: 46px;\n\tbackground: #F7FAFF;\n\tborder-top-left-radius: 30px;\n\tborder-bottom-right-radius: 30px;\n\tz-index: 3;\n}\n\n.radiusColorTwo::after {\n\tcontent: '';\n\tposition: absolute;\n\tleft: -37px;\n\ttop: 0;\n\tright: auto;\n\twidth: 38px;\n\theight: 46px;\n\tbackground: #F7FAFF;\n\tborder-top-right-radius: 30px;\n\tborder-bottom-left-radius: 30px;\n\tz-index: 3;\n}\n\n.panelText {\n\tword-break: break-all !important;\n}\n\n/*************************Chat bubble Right & Left Styles end******************************************/\n/*************************Notification Message Styles start******************************************/\n.horizontalText {\n\toverflow: hidden;\n\ttext-align: center;\n}\n\n.textWrapper {\n\tposition: relative;\n}\n\n.textWrapper::before {\n\tcontent: \"\";\n\tposition: absolute;\n\tborder-bottom: 1px solid var(--border-secondary-color);\n\twidth: 500px;\n\ttop: 50%;\n\tright: 100%;\n\tmargin-right: 18px;\n}\n\n.textWrapper::after {\n\tcontent: \"\";\n\tposition: absolute;\n\tborder-bottom: 1px solid var(--border-secondary-color);\n\twidth: 500px;\n\ttop: 50%;\n\tleft: 100%;\n\tmargin-left: 18px;\n}\n\n/*************************Notification Message Styles end******************************************/\n.horizondalLine {\n\tmargin-top: 20px;\n\tmargin-bottom: 20px;\n\tborder: 0;\n\tborder-top: 1px solid var(--border-color);\n}\n\n.textLeft {\n\ttext-align: left;\n}\n\n.textRight {\n\ttext-align: right;\n}\n\n.textGray {\n\tcolor: #9b9b9b;\n\tfont-size: 14px;\n}\n\n.chevronIcon {\n\tfont-size: 1.5em;\n\tmargin-top: 10px;\n\tfont-weight: normal;\n\tfont-style: normal;\n}\n\n.timerIcon {\n\tfont-size: 1.5em;\n\tfont-weight: normal;\n\tfont-style: normal;\n\tposition: relative;\n\tbottom: 2px;\n}\n\n.checkInDate {\n\tfont-size: 14px;\n\tcolor: var(--common-text-color);\n}\n\n.pullLeft {\n\tfloat: left;\n}\n\n.pullRight {\n\tfloat: right;\n}\n\n/** Discount **/\n.discountText {\n\tcolor: #3fb34f;\n}\n\na,\na:hover,\na:focus,\na:active {\n\ttext-decoration: none;\n}\n\n.paddingRight {\n\tpadding: 0 0 0 35px;\n}\n\n.displayTable {\n\twidth: 100%;\n\tdisplay: table;\n}\n\n.displayTableRow {\n\twidth: 100%;\n\tdisplay: table-row;\n}\n\n.displayTableCell {\n\tdisplay: table-cell;\n\tvertical-align: top;\n}\n\n.displayTableWidth {\n\twidth: 100%;\n\tposition: relative;\n}\n\n.profileAvatarSection {\n\tmargin: 0 0 0 6px;\n\tposition: relative;\n\tz-index: 5;\n}\n\n.displayTableCellTop {\n\tdisplay: table-cell;\n\tvertical-align: top;\n}\n\n.profileAvatarSectionLeft {\n\tposition: relative;\n\tz-index: 5;\n\tmargin: 0px 6px 0 0px;\n}\n\n.guestHost {\n\ttext-align: center;\n\tmargin-bottom: 25px;\n\tbackground: #fff;\n\tpadding: 10px 0;\n}\n\n.hostChat {\n\tdisplay: inline-block;\n\tvertical-align: middle;\n}\n\n.hostChat img {\n\twidth: 110px;\n\tborder-radius: 50%;\n\tborder: 2px solid #fff;\n}\n\n.centerChatIcon {\n\theight: 45px;\n\twidth: 45px;\n\tmargin-left: -20px;\n\tmargin-right: -20px;\n\tposition: relative;\n\tz-index: 2;\n\ttext-align: center;\n\tdisplay: inline-block;\n\tvertical-align: middle;\n}\n\n.iconBG {\n\tborder-radius: 50%;\n\tborder: 2px solid #ccc;\n\tborder-width: 2px !important;\n\tbackground-color: #fff;\n\ttext-align: center;\n\theight: 45px;\n\twidth: 45px;\n}\n\n.iconBG img {\n\twidth: 65%;\n\tdisplay: inline-block;\n\tpadding: 9px 0 0 0\n}\n\n.hostName {\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tbackground: #fff;\n\tpadding: 10px;\n\tcolor: var(--common-text-color);\n\tfont-size: 15px;\n\twidth: 20%;\n\ttext-overflow: ellipsis;\n\toverflow: hidden;\n\twhite-space: nowrap;\n}\n\n.instantIcon {\n\tmargin-top: -4px;\n}\n\n.positionR {\n\tposition: relative;\n}\n\n.infoContentBlock {\n\tbackground-color: #F8F7FD;\n}\n\n.contentBlockHeading {\n\tfont-size: 18px;\n\tmargin-bottom: 12px;\n\tmargin-top: 0;\n\tfont-weight: 600;\n}\n\n.contentSectionBtn {\n\tmargin-top: 20px;\n\tdisplay: flex;\n}\n\n.contentSubText {\n\tfont-size: 16px;\n}\n\n/* =============New css ================*/\n.tripDetailHeading {\n\tfont-size: 16px;\n}\n\n.tripDetailGrey {\n\tcolor: var(--common-text-Secondry-color);\n\tfont-size: 16px;\n}\n\n.paymentDetailText {\n\tcolor: var(--common-text-Secondry-color);\n\tfont-size: 16px;\n\tmargin-bottom: 10px;\n}\n\n.paymentTotal {\n\tfont-size: 18px;\n}\n\n.messageBoxBg {\n\tbackground-color: var(--background-common-color);\n\tpadding: 20px 20px 40px 20px;\n\tborder-radius: 8px;\n}\n\n.messageBoxStyle {\n\twidth: 90%;\n}\n\n.topMessageBar {\n\tbackground-color: transparent;\n}\n\n.messageSendIcon,\n.messageSendIcon:hover,\n.messageSendIcon:active,\n.messageSendIcon:focus {\n\tbackground: transparent !important;\n\tborder: 0 !important;\n\toutline: none;\n\tbox-shadow: none !important;\n\tpadding: 0;\n\tposition: relative;\n\tz-index: 5\n}\n\n.paddingNone {\n\tpadding: 0;\n}\n\n.messageBoxSection {\n\tpadding: 20px;\n\tbackground-color: var(--background-common-color);\n\tborder-top-left-radius: 8px;\n\tborder-top-right-radius: 8px;\n}\n\n.panelBubble {\n\tmargin-bottom: 0;\n}\n\n.userDetailSec {\n\tdisplay: flex;\n\tjustify-content: center;\n\tgap: 18px;\n\talign-items: center;\n\tmargin-bottom: 22px;\n}\n\n.userDetailHostName {\n\tfont-size: 16px;\n}\n\n.font16 {\n\tfont-size: 16px;\n}\n\n.nameSection {\n\tmargin-bottom: 8px;\n}\n\n.verifyReviewCountSec {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 3px;\n}\n\n.statusText {\n\tfont-size: 16px;\n\tpadding-right: 8px;\n}\n\n.dotText {\n\twidth: 4px;\n\theight: 4px;\n\tborder-radius: 50%;\n\tbackground-color: var(--common-text-color);\n\tposition: absolute;\n\ttop: 38%;\n\n}\n\n.dateText {\n\tfont-size: 14px;\n\tcolor: var(--common-text-Secondry-color);\n\tpadding-left: 8px;\n}\n\n.messageThreadSection {\n\tpadding: 0 20px 40px 20px;\n}\n\n.topRadiusColor::after {\n\tright: 50px;\n\ttop: 20px;\n\tborder-left: 1px solid var(--border-color);\n\tbackground: var(--background-common-color);\n}\n\n.topMessageBar::before {\n\tright: -23px;\n\ttop: 1px;\n\tleft: auto;\n}\n\n.panelBubbleLeft {\n\tbackground-color: #ffffff;\n\tpadding: 17px;\n}\n\n.panelSendToBubble {\n\tbackground-color: #EDF4FF;\n\tpadding: 17px;\n}\n\n.fromRadius:after {\n\tleft: 0px;\n\ttop: 0;\n\tright: auto;\n\twidth: 46px;\n\tborder-top-right-radius: 30px;\n\tborder-bottom-left-radius: 30px;\n\tbackground: var(--background-common-color);\n}\n\n.toRadius:after {\n\tright: 4px;\n\ttop: -1px;\n\tleft: auto;\n\twidth: 46px;\n\tborder-top-left-radius: 30px;\n\tborder-bottom-right-radius: 30px;\n}\n\n.panelSendToBubble:before {\n\tborder-color: #EDF4FF transparent transparent;\n}\n\n.panelSendToBubble::after {\n\tcontent: '';\n\tposition: absolute;\n\tright: -45px;\n\ttop: -1px;\n\tleft: auto;\n\twidth: 46px;\n\theight: 46px;\n\tbackground: var(--background-common-color);\n\tborder-top-left-radius: 30px;\n\tborder-bottom-right-radius: 30px;\n\tz-index: 3;\n\ttransform: rotate(-14deg);\n\n}\n\n.panelLeftMessage {\n\tborder-radius: 0 8px 8px 8px;\n}\n\n.panelRightMessage {\n\tborder-radius: 8px 0 8px 8px;\n}\n\n.messageDateText {\n\tcolor: var(--common-text-Secondry-color);\n\tfont-size: 10px;\n}\n\n.txtBreak {\n\tword-break: break-word;\n}\n\n.messageProfilePicSec {\n\twidth: 50px;\n}\n\n.width100 {\n\twidth: 100%;\n}\n\n.messageBoxFlex {\n\tdisplay: flex;\n\tposition: relative;\n}\n\n.profileAvatarSection {\n\twidth: 48px;\n}\n\n.profileAvatarSectionLeft .profileAvatarLink {\n\tposition: relative;\n\tright: 3px;\n\ttop: 1px;\n}\n\n.tripCheckinCheckout {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n}\n\n.userDetailDotText {\n\twidth: 3px;\n\theight: 3px;\n\tborder-radius: 50%;\n\tbackground-color: var(--common-text-Secondry-color);\n\tposition: relative;\n\tmargin-top: 7px;\n\tmargin-left: 7px;\n\tmargin-right: 7px;\n}\n\n.tripArrowSec {\n\tmargin: 0 10px;\n}\n\n.checkDate {\n\tword-break: break-word;\n}\n\n.paymentFlex {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tcolumn-gap: 5px;\n}\n\n.timerSection {\n\tdisplay: flex;\n\tcolumn-gap: 3px;\n}\n\n/* ==============New css============== */\n.msgSendIcon {\n\twidth: 100%;\n\tmax-width: 72px;\n\tmin-width: 72px;\n}\n\n.deleteButton {\n\tbackground: red;\n\tpadding: 5px;\n\tcolor: white;\n\tborder-radius: 12px;\n\tborder-style: none;\n\toutline: none;\n\tmargin-top: 10px;\n}\n\n@media (max-width: 1023px) and (min-width: 768px) {\n\t.noPaddingRight {\n\t\tpadding-right: 0;\n\t}\n\n\t.hostChat img {\n\t\twidth: 95px;\n\t}\n\n\t.iconBG img {\n\t\tpadding: 8px 0 0 0;\n\t}\n\n\t.iconBG {\n\t\theight: 40px;\n\t\twidth: 40px;\n\t}\n\n\t.centerChatIcon {\n\t\theight: 40px;\n\t\twidth: 40px;\n\t}\n\n\t.hostName {\n\t\twidth: 25%;\n\t\ttext-overflow: ellipsis;\n\t\toverflow: hidden;\n\t\twhite-space: nowrap;\n\t}\n\n\t.hostNameColor {\n\t\tcolor: var(--common-text-color) !important;\n\t}\n}\n\n@media (max-width: 767px) {\n\t.paddingRight {\n\t\tpadding: 0 0 0 0;\n\t}\n\n\t.panelBubbleRight::before {\n\t\tdisplay: none !important;\n\t}\n\n\t.panelBubbleLeft::before {\n\t\tdisplay: none !important;\n\t}\n\n\t.panelBubbleRight::after {\n\t\tdisplay: none;\n\t}\n\n\t.panelBubbleLeft::after {\n\t\tdisplay: none;\n\t}\n\n\t.profileAvatarSection {\n\t\tmargin: 0 0 0 13px;\n\t}\n\n\t.displayTableWidth {\n\t\twidth: 100%;\n\t}\n\n\t.displayTableWidthTwo {\n\t\twidth: 20%;\n\t}\n\n\t.profileAvatarSectionLeft {\n\t\tmargin: 0 10px 0 0;\n\t\tposition: relative;\n\t\tz-index: 5;\n\t}\n\n\t.radiusColor::after {\n\t\tdisplay: none;\n\t}\n\n\t.radiusColorTwo::after {\n\t\tdisplay: none;\n\t}\n\n\t.displayTableCell {\n\t\tdisplay: table-cell;\n\t\tvertical-align: middle;\n\t}\n\n\t.tripDetailGrey {\n\t\tfont-size: 14px;\n\t}\n\n\t.paymentDetailText {\n\t\tfont-size: 14px;\n\t}\n\n\t.paymentTotal {\n\t\tfont-size: 16px;\n\t}\n\n\t.tripDetailHeading {\n\t\tfont-size: 15px;\n\t}\n\n\t.userDetailSec {\n\t\tflex-direction: column;\n\t}\n\n\t.profileDetail {\n\t\tjustify-content: center;\n\t}\n\n\t.msgSendIcon {\n\t\tmax-width: 55px;\n\t\tmin-width: 55px;\n\t}\n\n\t.panelLeftMessage {\n\t\tborder-radius: 8px !important;\n\t}\n\n\t.panelRightMessage {\n\t\tborder-radius: 8px !important;\n\t}\n\n\t.sidebarDesign {\n\t\tpadding-top: 25px;\n\t}\n}\n\n@media screen and (max-width: 768px) {\n\t.hideSm {\n\t\tdisplay: none;\n\t}\n}\n\n@media (max-width: 320px) {\n\t.noPaddingRight {\n\t\tpadding-right: 0;\n\t}\n}\n\n@media screen and (min-width:1281px) {\n\t/* .messageBoxBg{\n\t\theight: 650px;\n\t\toverflow-y:scroll ;\n\t} */\n\t/* .messageBoxSection{\n\t\tposition: sticky;\n\t\tz-index: 7;\n\t\ttop: 0px;\n\t} */\n\n}\n\n.displayFlex {\n\tdisplay: flex;\n}\n\n@media screen and (min-width:768px) {\n\t.messageSendBtnSec {\n\t\tposition: relative;\n\t}\n\n\t.messageSendIcon::before {\n\t\tcontent: '';\n\t\tposition: absolute;\n\t\twidth: 25px;\n\t\theight: 1px;\n\t\tbackground-color: var(--border-color);\n\t\tleft: -3px;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorMessage": `ViewReviewAdminMessage-errorMessage-mlefL`,
	"space1": `ViewReviewAdminMessage-space1-eGfZT`,
	"space2": `ViewReviewAdminMessage-space2-FqB1z`,
	"space3": `ViewReviewAdminMessage-space3-GV73R`,
	"space4": `ViewReviewAdminMessage-space4-DwRUf`,
	"space5": `ViewReviewAdminMessage-space5-S_1Z9`,
	"space6": `ViewReviewAdminMessage-space6-Bt7HM`,
	"space7": `ViewReviewAdminMessage-space7-zl_tt`,
	"spaceTop8": `ViewReviewAdminMessage-spaceTop8-DNpbU`,
	"spaceTop1": `ViewReviewAdminMessage-spaceTop1-brLOg`,
	"spaceTop2": `ViewReviewAdminMessage-spaceTop2-vV9ei`,
	"spaceTop3": `ViewReviewAdminMessage-spaceTop3-arLsW`,
	"spaceTop4": `ViewReviewAdminMessage-spaceTop4-OQUrX`,
	"spaceTop5": `ViewReviewAdminMessage-spaceTop5-pXgwv`,
	"spaceTop6": `ViewReviewAdminMessage-spaceTop6-xkGJd`,
	"spaceTop7": `ViewReviewAdminMessage-spaceTop7-hN96p`,
	"noMargin": `ViewReviewAdminMessage-noMargin-UJrFk`,
	"padding1": `ViewReviewAdminMessage-padding1-Tbxwz`,
	"padding2": `ViewReviewAdminMessage-padding2-S0KBp`,
	"padding3": `ViewReviewAdminMessage-padding3-e_Fya`,
	"padding4": `ViewReviewAdminMessage-padding4-R19Yk`,
	"padding5": `ViewReviewAdminMessage-padding5-nfoCM`,
	"padding6": `ViewReviewAdminMessage-padding6-vAZ4N`,
	"padding7": `ViewReviewAdminMessage-padding7-_7hcl`,
	"paddingTop1": `ViewReviewAdminMessage-paddingTop1-Fsbh5`,
	"paddingTop2": `ViewReviewAdminMessage-paddingTop2-bg74U`,
	"paddingTop3": `ViewReviewAdminMessage-paddingTop3-kQzC7`,
	"paddingTop4": `ViewReviewAdminMessage-paddingTop4-k1Vqt`,
	"paddingTop5": `ViewReviewAdminMessage-paddingTop5-OTRQt`,
	"paddingTop6": `ViewReviewAdminMessage-paddingTop6-lfs10`,
	"paddingTop7": `ViewReviewAdminMessage-paddingTop7-Rjya9`,
	"noPadding": `ViewReviewAdminMessage-noPadding-Mf6uJ`,
	"textBold": `ViewReviewAdminMessage-textBold-wFQzB`,
	"textBolder": `ViewReviewAdminMessage-textBolder-PMJfI`,
	"textNormal": `ViewReviewAdminMessage-textNormal-amgd0`,
	"spaceBottom20": `ViewReviewAdminMessage-spaceBottom20-tuz1W`,
	"spaceBottom10": `ViewReviewAdminMessage-spaceBottom10-sQ1wo`,
	"marginNone": `ViewReviewAdminMessage-marginNone-kzEDQ`,
	"spaceBottom15": `ViewReviewAdminMessage-spaceBottom15-lc1yk`,
	"marginTopNone": `ViewReviewAdminMessage-marginTopNone-ecWgC`,
	"spaceTop11": `ViewReviewAdminMessage-spaceTop11-LqhJ7`,
	"spaceTop21": `ViewReviewAdminMessage-spaceTop21-gBdw_`,
	"spaceTop20": `ViewReviewAdminMessage-spaceTop20-DNpIG`,
	"spaceTop10": `ViewReviewAdminMessage-spaceTop10-P6hgy`,
	"textDarkBlue": `ViewReviewAdminMessage-textDarkBlue-UZPtO`,
	"textLightBlue": `ViewReviewAdminMessage-textLightBlue-GtCBz`,
	"textLightSandleGreen": `ViewReviewAdminMessage-textLightSandleGreen-GSW1X`,
	"textLightBrown": `ViewReviewAdminMessage-textLightBrown-goVPB`,
	"textMediumMaroon": `ViewReviewAdminMessage-textMediumMaroon-b3oPV`,
	"textBrown": `ViewReviewAdminMessage-textBrown-zWwEj`,
	"textMaroon": `ViewReviewAdminMessage-textMaroon-s1IFt`,
	"textDarkBrown": `ViewReviewAdminMessage-textDarkBrown-ONARL`,
	"textMediumBrown": `ViewReviewAdminMessage-textMediumBrown-D2ozj`,
	"textSkyBlue": `ViewReviewAdminMessage-textSkyBlue-gnbop`,
	"textGray": `ViewReviewAdminMessage-textGray-L01e2`,
	"btnRadius": `ViewReviewAdminMessage-btnRadius-bvXK6`,
	"linkBtn": `ViewReviewAdminMessage-linkBtn-BHA2r`,
	"noBorder": `ViewReviewAdminMessage-noBorder-cA3Nm`,
	"sidebarDesign": `ViewReviewAdminMessage-sidebarDesign-w9Svl`,
	"sidebarContainer": `ViewReviewAdminMessage-sidebarContainer-F8jAP`,
	"textCenter": `ViewReviewAdminMessage-textCenter-yzFHy`,
	"profileAvatarSection": `ViewReviewAdminMessage-profileAvatarSection-gdrPI`,
	"profileAvatarLink": `ViewReviewAdminMessage-profileAvatarLink-Ow8rd`,
	"profileName": `ViewReviewAdminMessage-profileName-ObobG`,
	"profileDetail": `ViewReviewAdminMessage-profileDetail-zrGep`,
	"horizontalLine": `ViewReviewAdminMessage-horizontalLine-QIXYd`,
	"textLeft": `ViewReviewAdminMessage-textLeft-RcUgx`,
	"textRight": `ViewReviewAdminMessage-textRight-m0R9F`,
	"contextPadding": `ViewReviewAdminMessage-contextPadding-JW9NL`,
	"rowCondensed": `ViewReviewAdminMessage-rowCondensed-Wz_lc`,
	"textBody": `ViewReviewAdminMessage-textBody-IeKew`,
	"bottomButton": `ViewReviewAdminMessage-bottomButton-DDcSh`,
	"textAreaBox": `ViewReviewAdminMessage-textAreaBox-iM7zT`,
	"btnRight": `ViewReviewAdminMessage-btnRight-Ec9zj`,
	"panelDark": `ViewReviewAdminMessage-panelDark-oj0A_`,
	"timeText": `ViewReviewAdminMessage-timeText-n51_S`,
	"panelQuote": `ViewReviewAdminMessage-panelQuote-uJKpo`,
	"panelBubble": `ViewReviewAdminMessage-panelBubble-mt33I`,
	"panelBubbleLeft": `ViewReviewAdminMessage-panelBubbleLeft-ulQL3`,
	"panelBubbleRight": `ViewReviewAdminMessage-panelBubbleRight-vESvs`,
	"radiusColor": `ViewReviewAdminMessage-radiusColor-tYXyK`,
	"radiusColorTwo": `ViewReviewAdminMessage-radiusColorTwo-V5yNJ`,
	"panelText": `ViewReviewAdminMessage-panelText-Xfp1y`,
	"horizontalText": `ViewReviewAdminMessage-horizontalText-yNWko`,
	"textWrapper": `ViewReviewAdminMessage-textWrapper-jkLzs`,
	"horizondalLine": `ViewReviewAdminMessage-horizondalLine-IXWO3`,
	"chevronIcon": `ViewReviewAdminMessage-chevronIcon-zkzde`,
	"timerIcon": `ViewReviewAdminMessage-timerIcon-KYJGX`,
	"checkInDate": `ViewReviewAdminMessage-checkInDate-n2gq9`,
	"pullLeft": `ViewReviewAdminMessage-pullLeft-f8sbV`,
	"pullRight": `ViewReviewAdminMessage-pullRight-j6X6s`,
	"discountText": `ViewReviewAdminMessage-discountText-lfMwx`,
	"paddingRight": `ViewReviewAdminMessage-paddingRight-Zp8eq`,
	"displayTable": `ViewReviewAdminMessage-displayTable-okOyH`,
	"displayTableRow": `ViewReviewAdminMessage-displayTableRow-XeOtV`,
	"displayTableCell": `ViewReviewAdminMessage-displayTableCell-bhZDv`,
	"displayTableWidth": `ViewReviewAdminMessage-displayTableWidth-Dw8re`,
	"displayTableCellTop": `ViewReviewAdminMessage-displayTableCellTop-k_QIO`,
	"profileAvatarSectionLeft": `ViewReviewAdminMessage-profileAvatarSectionLeft-tsElY`,
	"guestHost": `ViewReviewAdminMessage-guestHost-dXIi3`,
	"hostChat": `ViewReviewAdminMessage-hostChat-GVdgK`,
	"centerChatIcon": `ViewReviewAdminMessage-centerChatIcon-sXkO4`,
	"iconBG": `ViewReviewAdminMessage-iconBG-w3sSJ`,
	"hostName": `ViewReviewAdminMessage-hostName-c5BIC`,
	"instantIcon": `ViewReviewAdminMessage-instantIcon-uyGi1`,
	"positionR": `ViewReviewAdminMessage-positionR-DIgoq`,
	"infoContentBlock": `ViewReviewAdminMessage-infoContentBlock-yMb4G`,
	"contentBlockHeading": `ViewReviewAdminMessage-contentBlockHeading-qpPCC`,
	"contentSectionBtn": `ViewReviewAdminMessage-contentSectionBtn-jkvdr`,
	"contentSubText": `ViewReviewAdminMessage-contentSubText-aGzVy`,
	"tripDetailHeading": `ViewReviewAdminMessage-tripDetailHeading-h5RLI`,
	"tripDetailGrey": `ViewReviewAdminMessage-tripDetailGrey-tkNGV`,
	"paymentDetailText": `ViewReviewAdminMessage-paymentDetailText-yEkGs`,
	"paymentTotal": `ViewReviewAdminMessage-paymentTotal-Gor6q`,
	"messageBoxBg": `ViewReviewAdminMessage-messageBoxBg-rAAEr`,
	"messageBoxStyle": `ViewReviewAdminMessage-messageBoxStyle-U2rTt`,
	"topMessageBar": `ViewReviewAdminMessage-topMessageBar-mD4wf`,
	"messageSendIcon": `ViewReviewAdminMessage-messageSendIcon-N6Bjb`,
	"paddingNone": `ViewReviewAdminMessage-paddingNone-VxysI`,
	"messageBoxSection": `ViewReviewAdminMessage-messageBoxSection-pMjJN`,
	"userDetailSec": `ViewReviewAdminMessage-userDetailSec-m_6L8`,
	"userDetailHostName": `ViewReviewAdminMessage-userDetailHostName-_E0Lj`,
	"font16": `ViewReviewAdminMessage-font16-fkdfi`,
	"nameSection": `ViewReviewAdminMessage-nameSection-_GOGQ`,
	"verifyReviewCountSec": `ViewReviewAdminMessage-verifyReviewCountSec-i7Z9l`,
	"statusText": `ViewReviewAdminMessage-statusText-DWSvW`,
	"dotText": `ViewReviewAdminMessage-dotText-S2bkS`,
	"dateText": `ViewReviewAdminMessage-dateText-XD4fU`,
	"messageThreadSection": `ViewReviewAdminMessage-messageThreadSection-T68oq`,
	"topRadiusColor": `ViewReviewAdminMessage-topRadiusColor-BatCj`,
	"panelSendToBubble": `ViewReviewAdminMessage-panelSendToBubble-BRxdt`,
	"fromRadius": `ViewReviewAdminMessage-fromRadius-GxNX_`,
	"toRadius": `ViewReviewAdminMessage-toRadius-DoNLn`,
	"panelLeftMessage": `ViewReviewAdminMessage-panelLeftMessage-lbjDV`,
	"panelRightMessage": `ViewReviewAdminMessage-panelRightMessage-M2pro`,
	"messageDateText": `ViewReviewAdminMessage-messageDateText-pJ2yz`,
	"txtBreak": `ViewReviewAdminMessage-txtBreak-IstlX`,
	"messageProfilePicSec": `ViewReviewAdminMessage-messageProfilePicSec-LRZqf`,
	"width100": `ViewReviewAdminMessage-width100-icj74`,
	"messageBoxFlex": `ViewReviewAdminMessage-messageBoxFlex-PdQYs`,
	"tripCheckinCheckout": `ViewReviewAdminMessage-tripCheckinCheckout-Sbq7w`,
	"userDetailDotText": `ViewReviewAdminMessage-userDetailDotText-sZd41`,
	"tripArrowSec": `ViewReviewAdminMessage-tripArrowSec-Zph1_`,
	"checkDate": `ViewReviewAdminMessage-checkDate-IuAOK`,
	"paymentFlex": `ViewReviewAdminMessage-paymentFlex-yRd2y`,
	"timerSection": `ViewReviewAdminMessage-timerSection-okZb0`,
	"msgSendIcon": `ViewReviewAdminMessage-msgSendIcon-xSw0Y`,
	"deleteButton": `ViewReviewAdminMessage-deleteButton-uZ3gA`,
	"noPaddingRight": `ViewReviewAdminMessage-noPaddingRight-eZ8vA`,
	"hostNameColor": `ViewReviewAdminMessage-hostNameColor-k63nN`,
	"displayTableWidthTwo": `ViewReviewAdminMessage-displayTableWidthTwo-x32A8`,
	"hideSm": `ViewReviewAdminMessage-hideSm-ETeWW`,
	"displayFlex": `ViewReviewAdminMessage-displayFlex-XlDaX`,
	"messageSendBtnSec": `ViewReviewAdminMessage-messageSendBtnSec-QbQXk`
};
module.exports = ___CSS_LOADER_EXPORT___;
